// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import waterfall from 'vue-waterfall2'
import AppMobile from './MobileApp'
import App from './App'
import router from './router'
import {  Menu,Submenu,MenuItem, MenuItemGroup, Card, Row,Col, Carousel,CarouselItem,} from 'element-ui';
import StrokeText from 'vue-stroke-text'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
// 全局注册
Vue.config.productionTip = false
Vue.use(Menu)
Vue.use(Submenu)
Vue.use(MenuItem)
Vue.use(MenuItemGroup)
Vue.use(Card)
Vue.use(Row)
Vue.use(Col)
Vue.use(Carousel)
Vue.use(CarouselItem)
Vue.use(waterfall);
Vue.component(StrokeText.name,StrokeText)
Vue.use(VueAwesomeSwiper, /* { default options with global component } */)
/* eslint-disable no-new */
if(navigator.userAgent.match(
  /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
)){
  new Vue({
    el: '#app',
    router,
    components: {AppMobile},
    template: '<AppMobile/>'
  })
}else{
  new Vue({
    el: '#app',
    router,
    components: {App},
    template: '<App/>'
  })
}





// WEBPACK FOOTER //
// ./src/main.js